// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4c35b0f4","453":"bbf4fe64","455":"e4db8252","977":"12738ec5"}[chunkId] + ".chunk.js";
};